import BaseCrudService from './baseCrud.service'

class UserService extends BaseCrudService {
  constructor () {
    super('prospect', {
      'id': false,
      'first_name': '',
      'last_name': '',
      'isIndividual': false,
      'agency_id': 0,
      'email': ''
    })
  }

  setPassword (id, data, ...callbacks) {
    this.constructor.post(this.endpoints().setPassword.replace('{:id}', id), { 'password': data.np }, ...callbacks)
  }
}

export default UserService
